export default [
  {
    path: '/manage/clazz/create',
    name: 'clazzcreate',
    component: () => import('@/views/manage/create.vue')
  },
  {
    path: '/manage/clazz/list',
    name: 'clazzmanagelist',
    component: () => import('@/views/manage/managelist.vue')
  },
  {
    path: '/manage/clazz/:clazz_id(\\w+)',
    name: 'clazzmanage',
    component: () => import('@/views/manage/manage.vue')
  },
  {
    path: '/manage/clazz/:clazz_id(\\w+)/detail',
    name: 'clazzmanagedetail',
    component: () => import('@/views/manage/managedetail.vue')
  },
  {
    path: '/manage/clazz/:clazz_id(\\w+)/changecover',
    name: 'clazzchangecover',
    component: () => import('@/views/manage/changecover.vue')
  },
  {
    path: '/manage/clazz/:clazz_id(\\w+)/record',
    name: 'clazzmanagerecord',
    component: () => import('@/views/manage/managerecord.vue')
  },
  {
    path: '/manage/clazz/:clazz_id(\\w+)/user',
    name: 'clazzmanageuser',
    component: () => import('@/views/manage/manageuser.vue')
  },
  {
    path: '/manage/clazz/:clazz_id(\\w+)/user/:user_id(\\w+)/data',
    name: 'clazzmanageuserdata',
    component: () => import('@/views/manage/manageuserdata.vue')
  },
  {
    path: '/manage/clazz/:clazz_id(\\w+)/rank',
    name: 'clazzmanagerank',
    component: () => import('@/views/manage/managerank.vue')
  }
]
